import { apiFetch } from './client.js';
import type { SignatureCodes } from './coach-signature.js';

/**
 * Clients, for the MPC coach (mockup *Clients and Texted Links* v8, approved
 * 21 October): every family, one family, Add a family, Edit details, and a
 * fresh sign-up link to share.
 */

type GetToken = () => Promise<string | null>;

export interface ClientRow {
  adult_account_id: string;
  parent_name: string;
  athletes: string[];
  signed_up: boolean;
}

export interface ClientFamily {
  adult_account_id: string;
  parent_first_name: string;
  parent_last_name: string;
  phone: string | null;
  email: string | null;
  signed_up: boolean;
  country: string;
  /** signature: the athlete's Performance Signature codes, null when none is saved. */
  athletes: { id: string; first_name: string; last_name: string; signature: SignatureCodes | null }[];
  /** The holder, then a second parent not removed, each with their codes (25 October). */
  parents: { id: string; first_name: string; last_name: string; signature: SignatureCodes | null }[];
  lessons: {
    lesson_id: string;
    athlete_name: string;
    start: string;
    end: string;
    timezone: string;
    facility_name: string;
    cage: string;
    cancelled: boolean;
  }[];
}

/** What Add a family and Edit details send; an athlete with an id is one already on the family. */
export interface FamilyDraft {
  parent_first_name: string;
  parent_last_name: string;
  parent_phone: string;
  parent_email: string;
  /** The parent's own page, for a parent with no birthday yet. */
  parent_needs_birthday?: boolean;
  parent_date_of_birth?: string;
  athletes: {
    id?: string;
    first_name: string;
    last_name: string;
    /** The parent's own page, for an athlete with no birthday yet. */
    needs_birthday?: boolean;
    date_of_birth?: string;
  }[];
}

export function listClients(getToken: GetToken, query: string): Promise<{ families: ClientRow[] }> {
  return apiFetch(`/api/coach/clients?q=${encodeURIComponent(query)}`, getToken);
}

export function readClient(getToken: GetToken, adultAccountId: string): Promise<ClientFamily> {
  return apiFetch(`/api/coach/clients/${encodeURIComponent(adultAccountId)}`, getToken);
}

export function addClient(getToken: GetToken, draft: FamilyDraft): Promise<{ adult_account_id: string; emailed: boolean }> {
  return apiFetch('/api/coach/clients', getToken, { method: 'POST', body: JSON.stringify(draft) });
}

export function updateClient(getToken: GetToken, adultAccountId: string, draft: FamilyDraft): Promise<{ emailed: boolean }> {
  return apiFetch(`/api/coach/clients/${encodeURIComponent(adultAccountId)}`, getToken, {
    method: 'PUT',
    body: JSON.stringify(draft),
  });
}

export function makeClientLink(getToken: GetToken, adultAccountId: string): Promise<{ path: string; coach_name: string }> {
  return apiFetch(`/api/coach/clients/${encodeURIComponent(adultAccountId)}/links`, getToken, { method: 'POST' });
}

/** "(425) 555-0142" for a US or Canada number; anything else as kept. */
export function shownPhone(phone: string | null): string {
  if (!phone) return '';
  const us = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(phone);
  return us ? `(${us[1]}) ${us[2]}-${us[3]}` : phone;
}
